// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React, { MouseEvent } from "react";

import { Lifecycle, Setter, scrollIntoViewSoon } from "../UiUtil";
import { Concern, isValidationError } from "./ValidatedUI";
import { createOuts } from "../util";

const { debug } = createOuts("SaveButton", true);

interface SaveButtonProps {
  lifecycle: Lifecycle;
  setLifecycle: Setter<Lifecycle>;
  concerns: { [key: string]: Concern | null };
  onSave: () => Promise<any>;
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  lifecycle,
  setLifecycle,
  concerns,
  onSave,
}) => {
  debug("concerns", concerns);
  const anyErrors = Object.keys(concerns)
    .map(key => concerns[key])
    .some(isValidationError);

  async function save(event: MouseEvent<HTMLButtonElement>) {
    scrollIntoViewSoon(event.currentTarget);

    let success = false;
    setLifecycle(Lifecycle.SAVING);
    try {
      await onSave();
      success = true;
    } finally {
      setLifecycle(success ? Lifecycle.SAVED : lifecycle);
    }
  }

  return anyErrors ? (
    <></>
  ) : (
      <button
        type="button"
        onClick={save}
        disabled={lifecycle !== Lifecycle.EDITED}
      >
        {lifecycle === Lifecycle.SAVED
          ? "Saved"
          : lifecycle === Lifecycle.SAVING
            ? "Saving.."
            : "Save"}
      </button>
    );
};
